<div
  class="relative flex h-dvh w-full flex-col items-center justify-center overflow-hidden px-4 mt-10"
>
  <!-- Gradient border shell -->
  <div
    class="relative w-full max-w-lg rounded-3xl bg-gradient-to-br from-purple-500/40 via-indigo-500/30 to-blue-500/40 p-[1.5px] shadow-2xl shadow-indigo-500/10 dark:shadow-black/40"
  >
    <div
      class="relative overflow-hidden rounded-[calc(1.5rem-1px)] bg-white/90 backdrop-blur-xl px-6 py-7 sm:px-8 sm:py-8 dark:bg-gray-900/90"
    >
      <!-- Top sheen -->
      <div
        class="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/70 to-transparent dark:via-white/20"
      ></div>

      <!-- Header -->
      <div class="mb-6">
        <div class="flex items-center gap-3">
          <div
            class="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-600 via-indigo-600 to-blue-500 shadow-lg shadow-indigo-500/30"
          >
            <svg
              class="h-5 w-5 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M19 8v6M22 11h-6" />
            </svg>
          </div>
          <div>
            <h1
              class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white"
            >
              Create your
              <span
                class="bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-500 bg-clip-text text-transparent dark:from-purple-400 dark:via-indigo-400 dark:to-cyan-400"
                >account</span
              >
            </h1>
          </div>
        </div>
      </div>

      <form [formGroup]="userForm" class="space-y-5">
        <!-- First Name + Last Name -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <!-- First Name -->
          <div class="flex flex-col gap-1.5">
            <label for="su-first-name" class="text-sm font-medium text-gray-700 dark:text-gray-300">
              First Name <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <span
                class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
              >
                <svg
                  class="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </span>
              <input id="su-first-name"
                type="text"
                pInputText
                maxlength="15"
                class="w-full rounded-xl border border-gray-200 bg-white py-2.5 pl-3 pr-10 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:focus:ring-indigo-900"
                placeholder="Enter your first name"
                formControlName="first_name"
              />
            </div>
            <small
              *ngIf="
                userForm.get('first_name')?.touched &&
                userForm.get('first_name')?.invalid
              "
              class="flex items-center gap-1 text-xs text-red-500"
            >
              <i class="pi pi-exclamation-circle text-[11px]"></i>
              {{
                userForm.get("first_name")?.errors?.["required"]
                  ? "First name is required"
                  : "First name can only contain letters, spaces, hyphens and apostrophes (max 15)"
              }}
            </small>
          </div>

          <!-- Last Name -->
          <div class="flex flex-col gap-1.5">
            <label for="su-last-name" class="text-sm font-medium text-gray-700 dark:text-gray-300"
              >Last Name</label
            >
            <div class="relative">
              <span
                class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
              >
                <svg
                  class="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </span>
              <input id="su-last-name"
                type="text"
                pInputText
                maxlength="15"
                class="w-full rounded-xl border border-gray-200 bg-white py-2.5 pl-3 pr-10 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:focus:ring-indigo-900"
                placeholder="Enter your last name"
                formControlName="last_name"
              />
            </div>
            <small
              *ngIf="
                userForm.get('last_name')?.touched &&
                userForm.get('last_name')?.invalid
              "
              class="flex items-center gap-1 text-xs text-red-500"
            >
              <i class="pi pi-exclamation-circle text-[11px]"></i>
              {{
                userForm.get("last_name")?.errors?.["required"]
                  ? "Last name is required"
                  : "Last name can only contain letters, spaces, hyphens and apostrophes (max 15)"
              }}
            </small>
          </div>
        </div>

        <!-- Organization -->
        <div class="flex flex-col gap-1.5">
          <label for="su-org-name" class="text-sm font-medium text-gray-700 dark:text-gray-300"
            >Organization Name</label
          >
          <div class="relative">
            <span
              class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
            >
              <svg
                class="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M3 21h18M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" />
                <path d="M15 21V9h4a2 2 0 0 1 2 2v10" />
                <path d="M9 7h2M9 11h2M9 15h2" />
              </svg>
            </span>
            <input id="su-org-name"
              type="text"
              pInputText
              maxlength="50"
              class="w-full rounded-xl border border-gray-200 bg-white py-2.5 pl-3 pr-10 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:focus:ring-indigo-900"
              placeholder="Enter your organization name"
              formControlName="organisation_name"
            />
          </div>
        </div>

        <!-- Email -->
        <div class="flex flex-col gap-1.5">
          <label for="su-email" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Email <span class="text-red-500">*</span>
          </label>
          <div class="relative">
            <span
              class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
            >
              <svg
                class="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="2" y="4" width="20" height="16" rx="3" />
                <path d="m3 7 8.4 5.6a2 2 0 0 0 2.2 0L22 7" />
              </svg>
            </span>
            <input id="su-email"
              type="email"
              pInputText
              maxlength="254"
              class="w-full rounded-xl border border-gray-200 bg-white py-2.5 pl-3 pr-10 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:focus:ring-indigo-900"
              placeholder="Enter your email"
              formControlName="email"
            />
          </div>
          <small
            *ngIf="
              userForm.get('email')?.touched && userForm.get('email')?.invalid
            "
            class="flex items-center gap-1 text-xs text-red-500"
          >
            <i class="pi pi-exclamation-circle text-[11px]"></i>
            {{
              userForm.get("email")?.errors?.["required"]
                ? "Email is required"
                : "Enter valid email"
            }}
          </small>
        </div>

        <!-- Submit -->
        <button
          type="button"
          (click)="registerUser()"
          [disabled]="userForm.invalid || submitting"
          class="relative w-full overflow-hidden rounded-xl bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-500 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-500/30 transition hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span class="relative flex items-center justify-center gap-2">
            @if (submitting) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            {{ submitting ? 'Submitting...' : 'Sign Up' }}
          </span>
        </button>
      </form>

      <!-- Divider -->
      <div class="my-5 flex items-center gap-3">
        <span
          class="h-px flex-1 bg-gradient-to-r from-transparent to-gray-200 dark:to-white/10"
        ></span>
        <span class="text-[11px] uppercase tracking-widest text-gray-400"
          >or</span
        >
        <span
          class="h-px flex-1 bg-gradient-to-l from-transparent to-gray-200 dark:to-white/10"
        ></span>
      </div>

      <p class="text-center text-sm text-gray-600 dark:text-gray-400">
        Already have an account?
        <a routerLink="/signin" class="ml-1 font-semibold ..."> Sign In </a>
      </p>
    </div>
  </div>
</div>
<p-toast />
